<div class="min-h-screen flex flex-col bg-background text-primary">

  <app-header />

  <!-- Body: sidenav + content -->
  <div class="flex flex-1">
    @if (authService.isAuthenticated()) {
      <app-sidenav></app-sidenav>
    }
    <main class="min-w-0 flex-1 px-4 sm:px-6 lg:px-8 py-8">
      <router-outlet />
    </main>
  </div>

  <app-footer></app-footer>

  <app-toast-outlet />
</div>
